// src/web/NewsletterConfirm.jsx

import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NewsletterConfirm() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    fetch(`${apiUrl}/newsletter/confirm?token=${encodeURIComponent(token)}`)
      .then(res => res.json())
      .then(data => setStatus(data.status || 'error'))
      .catch(() => setStatus('error'));
  }, [searchParams, apiUrl]);

  return (
    <div className="system-page">
      <div className="system-content">
        {status === 'loading' && <p>{t('confirming_subscription')}...</p>}

        {status === 'success' && (
          <>
            <h2>{t('subscription_confirmed', 'Subscription confirmed')}</h2>
            <p>{t('thank_you_for_subscribing', 'Thank you for subscribing!')}</p>
            <Link to="/" className="web-button web-button--primary">{t('back_to_home', 'Back to home')}</Link>
          </>
        )}

        {status === 'notfound' && (
          <>
            <h2>{t('subscription_not_found', 'Subscription not found')}</h2>
            <p>{t('subscription_not_found_explanation', 'This confirmation link may have expired or is invalid.')}</p>
            <Link to="/" className="web-button web-button--primary">{t('back_to_home', 'Back to home')}</Link>
          </>
        )}

        {status === 'error' && (
          <>
            <h2>{t('error_occurred', 'An error occurred')}</h2>
            <p>{t('try_again_later', 'Please try again later.')}</p>
            <Link to="/" className="web-button web-button--primary">{t('back_to_home', 'Back to home')}</Link>
          </>
        )}
      </div>
    </div>
  );
}

export default NewsletterConfirm;
